import { get, put, post } from '../index'

export const getUserProfile = get('/user/profile')

export const getAccountInfo = get('/user/setting')
export const phoneVerifyCode = post('/user/phone/verifyCode')
export const updatePhone = put('/user/phone')